export default "__VITE_ASSET__CSW5IcUP__"